import { render, staticRenderFns } from "./PhoneNumberStatus.vue?vue&type=template&id=3a4978ba&scoped=true&"
import script from "./PhoneNumberStatus.vue?vue&type=script&lang=js&"
export * from "./PhoneNumberStatus.vue?vue&type=script&lang=js&"
import style0 from "./PhoneNumberStatus.vue?vue&type=style&index=0&id=3a4978ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a4978ba",
  null
  
)

export default component.exports